<template>
  <div class="title">
    <div class="title-text">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  color: $wet-asphalt;
  text-align: center;
  font-size: 2.2em;
  width: 100%;
  border-bottom: $border-title;
  margin-bottom: 40px;

  &-text {
    margin-bottom: 20px;
  }
}
</style>
